import { createUseStyles } from "react-jss";

export const ManagementUserFormOrganizationsTabStyle = createUseStyles((theme: any) => ({
    container: {
        width: "100%",
        overflowY: "auto",
        paddingTop: theme.paddings.sizes.base
    },
}));
